import { tv } from 'tailwind-variants'

export const styles = tv({
  slots: {
    wrapper: `
      bg-white
      max-w-6xl
      w-full
      mx-auto
      lg:max-h-screen
      lg:h-[calc(100vh-64px)]
      my-8
      shadow-lg
      rounded-xl
      lg:scroll-my-8
    `,
    header: `
      pt-8
      pb-4
      px-2
      lg:px-8
      sticky
      lg:relative
      top-0
      bg-white
      z-[1]
      rounded-[inherit]
      rounded-b-none
      border-b
      border-b-black-alpha-200
      shadow-lg-gray-100
    `,
    footer: `
      sticky
      pt-4
      bottom-0
      lg:relative
    `
  }
})
